import { logout } from '../../ducks/auth.duck';
import { vansiteDeleteUser } from '../../util/api';
import { storableError } from '../../util/errors';
import { logError } from '../../util/log';

// ================ Action types ================ //

export const DELETE_CURRENT_USER_REQUEST = 'app/DeleteUserPage/DELETE_CURRENT_USER_REQUEST';
export const DELETE_CURRENT_USER_SUCCESS = 'app/DeleteUserPage/DELETE_CURRENT_USER_SUCCESS';
export const DELETE_CURRENT_USER_ERROR = 'app/DeleteUserPage/DELETE_CURRENT_USER_ERROR';

// ================ Reducer ================ //

/** @type {import('../../../types/vansite').VanSite.State.DeleteUserPage} */
const initialState = {
  checkDeletionIsValid: false,
  checkDeletionIsValidInProgress: false,
  checkDeletionIsValidError: null,
  deletingInProgress: false,
  deletingError: null,
};

export default function payoutMethodsPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case DELETE_CURRENT_USER_REQUEST:
      return { ...state, deletingInProgress: true };
    case DELETE_CURRENT_USER_SUCCESS:
      return { ...state, deletingInProgress: false };
    case DELETE_CURRENT_USER_ERROR:
      return { ...state, deletingInProgress: false, deletingError: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

const deleteCurrentUserRequest = () => ({ type: DELETE_CURRENT_USER_REQUEST });
const deleteCurrentUserSuccess = () => ({ type: DELETE_CURRENT_USER_SUCCESS });
const deleteCurrentUserError = (error) => ({ type: DELETE_CURRENT_USER_ERROR, payload: { error } });

// ================ Thunks ================ //

export const deleteCurrentUser =
  (currentPassword, deleteReason, deleteDetails) => async (dispatch) => {
    dispatch(deleteCurrentUserRequest());
    try {
      const response = await vansiteDeleteUser({
        currentPassword,
        deleteData: { deleteReason, deleteDetails },
      });
      dispatch(deleteCurrentUserSuccess());
      dispatch(logout());
      return response;
    } catch (e) {
      logError(e, 'delete-user-failed');
      dispatch(deleteCurrentUserError(storableError(e)));
    }
  };

export const loadData = () => () => {
  return Promise.resolve();
};
